<template>
<fieldset
  class='assessment_question'
  :class='mainClass(question.id)'
>
<div class='assessment_question_inner'>
  <legend class='assessment_question-title'>
    <span>{{ index + 1 }}</span> {{ question.text }}
  </legend>

  <div
    v-if='question.content'
    class='assessment_question-content body-one'
    v-html='question.content'
  />

  <div
    v-if='show_result'
    class='assessment_question-result'
    :class='[questionResult(question.id) === "Correct" ? "correct" : "incorrect"]'
  >
    <div class='assessment_question-result_label body-one-light'>
      {{ questionResultText(question.id) }}
    </div>
  </div>

  <div class='assessment_question-options'>
    <template v-if='!is_question_with_image'>
      <ul>
        <li
          v-for='(option, i) in question.options'
          :key='i'
          :class='[isOptionSelected(section.id, question.id, option.id) ? "checked" : ""]'
          @click.prevent='select(section, question, option)'
        >
          <input
            :id='option.id'
            :type='answerInputType(question)'
            :name='question_name'
            :checked='isOptionSelected(section.id, question.id, option.id)'
            :disabled='disabled'
          >
          <label :for='option.id'>
            {{ option.text }}
          </label>
        </li>
      </ul>
    </template>

    <template v-if='is_question_with_image'>
      <div
        v-for='(option, i) in question.options'
        :key='i'
        class='assessment_question-card-wrapper'
        :class='[isOptionSelected(section.id, question.id, option.id) ? "checked" : ""]'
        @click.prevent='select(section, question, option)'
      >
        <input
          :id='option.id'
          type='radio'
          :name='question_name'
          :checked='isOptionSelected(section.id, question.id, option.id)'
          :disabled='disabled'
        >
        <label :for='option.id'>
          <div
            class='assessment_question-card'
            :class='cardClass(option)'
          >
            <div class='assessment_question-card_label'>
              {{ cardQuestionLabel(i) }}
            </div>
            <div
              class='assessment_question-card_image'
              :style='cardImage(option)'
            />
            <div
              v-if='option.text'
              class='assessment_question-card_text'
            >
              {{ option.text }}
            </div>
          </div>
        </label>
      </div>
    </template>
  </div>
</div>
</fieldset>
</template>

<script>
export default {
  props: [
    'section',
    'question',
    'index',

    'show_result',
    'select',
    'disabled',
    'isOptionSelected',
    'isQuestionCorrect'
  ],

  data() {
    return {
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    }
  },

  computed: {
    question_name() { return this.question.id + '[]' },

    is_question_with_image() {
      return !!this.question.options[0].option_image
    }
  },

  methods: {
    mainClass(question_id) {
      if (this.show_result) {
        return this.questionResult(question_id) === 'Correct' ? 'correct' : 'incorrect'
      }
    },

    cardQuestionLabel(index) {
      return this.letters[index]
    },

    cardImage(option) {
      return 'background-image: url(' + option.option_image + ')'
    },

    cardClass(option) {
      if (option.text) return 'has-text'
    },

    answerInputType(question) {
      if (question.kind === 'multiple_choice') return 'radio'
      if (question.kind === 'multiple_select') return 'checkbox'
    },

    questionResult(question_id) {
      return this.isQuestionCorrect(question_id) ? 'Correct' : 'Incorrect'
    },

    questionResultText(question_id) {
      return this.isQuestionCorrect(question_id) ? this.$t('correct') : this.$t('incorrect')
    }
  }

}
</script>

<style lang='sass' scoped>
@import './question'
</style>
